import { EntryStatusEnum } from '@clubspark-node/clubspark-tennis-types';

export const getTeamType = (selectedTeamsCount: number, alternateTeamsCount: number) => {
  if (selectedTeamsCount) return EntryStatusEnum.DIRECT_ACCEPTANCE;
  if (alternateTeamsCount) return EntryStatusEnum.ALTERNATE;
  return '';
};
